import type { LoaderFunction } from 'react-router-dom';
import { apiGetMostWinsWrestlerWomanListStats } from "../../components/ui_components/ApiList";

export const MostWinsFemaleResponsiveLoader: LoaderFunction = async ({ request }) => {
    try {
        const url = new URL(request.url);
        const year = url.searchParams.get('year') || 'globale';

        const response = await apiGetMostWinsWrestlerWomanListStats(1, year);
        return response;
    } catch (error) {
        console.error('Loader error:', error);
        throw new Error('Failed to load data');
    }
};
